export default {
    data() {
        return {
            // 后台管理用户基本信息
            form: {
                name: '',
                password: '',
            },
            // 权限列表
            permissionList: [
                {
                    permissionFlag: false,
                    permissionName: 'student_management_list',
                    permissionDesc: '学员管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'student_management',
                            permissionDesc: '学员管理列表权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'course_package_learning_status',
                            permissionDesc: '课程包学习情况列表权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'learning_situation',
                            permissionDesc: '学习情况权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'examination_results',
                            permissionDesc: '考试结果情况权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'courseware_learning',
                            permissionDesc: '课件学习情况权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'batch_elective',
                            permissionDesc: '批量选课权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'batch_classes',
                            permissionDesc: '批量开课权限',
                        },
                    ]
                },
                {
                    permissionFlag: false,
                    permissionName: 'course_management_list',
                    permissionDesc: '课程管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'course_management',
                            permissionDesc: '课程管理列表权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'course_package_management',
                            permissionDesc: '课程包管理权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'course_product_classification',
                            permissionDesc: '课程产品分类权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'course_product_list',
                            permissionDesc: '课程产品列表权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'activity_management',
                            permissionDesc: '活动管理权限',
                        },
                    ]
                },
                {
                    permissionFlag: false,
                    permissionName: 'resource_management',
                    permissionDesc: '资源管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'video_resources',
                            permissionDesc: '视频资源权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'test_resources',
                            permissionDesc: '试题资源权限',
                        },
                    ]
                },
                {
                    permissionFlag: false,
                    permissionName: 'payment_management_list',
                    permissionDesc: '支付管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'order_management',
                            permissionDesc: '订单管理权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'balance_management',
                            permissionDesc: '余额管理权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'invoice_management',
                            permissionDesc: '发票管理权限',
                        },
                    ]
                },
                {
                    permissionFlag: false,
                    permissionName: 'project_management_list',
                    permissionDesc: '项目管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'project_management',
                            permissionDesc: '项目权限',
                        },
                    ]
                },
                {
                    permissionFlag: false,
                    permissionName: 'website_management',
                    permissionDesc: '网站管理权限',
                    permissionDetail: [
                        {
                            permissionFlag: '0',
                            permissionName: 'article_management',
                            permissionDesc: '文章管理权限',
                        },
                        {
                            permissionFlag: '0',
                            permissionName: 'shuffling_figure',
                            permissionDesc: '轮播图权限',
                        },
                    ]
                },
            	{
            	    permissionFlag: false,
            	    permissionName: 'admin_management_list',
            	    permissionDesc: '超级管理员权限',
            	    permissionDetail: [
            	        {
            	            permissionFlag: '0',
            	            permissionName: 'background_user_management',
            	            permissionDesc: '后台用户管理权限',
            	        },
            	        {
            	            permissionFlag: '0',
            	            permissionName: 'delete_user_management',
            	            permissionDesc: '删除后台用户权限',
            	        },
            	    ]
            	},
            ],
            // 处理后的权限对象
            result: {},
            // 控制显示添加管理员对话框
            addUserVisible: false,
            // 控制显示修改管理员对话框
            editUserVisible: false,
            // 搜索条件
            serachForm: {
                name: '',
            },
            // 表格数据
            tableData: [],
            // 管理用户总条数
            total: 0,
            // 当前页
            currentPage: 1,
            // 显示条数
            pageSize: 10,
            // 用户修改的表单信息
            editForm: {
                user_id: '',
                name: '',
                password: '',
                is_disable: '',
                authority_management: '',
                authority_management_id: '',
            },
            // 管理员列表
            adminList: [],
            loading: false,
			//选择的管理员
            managementIds:[],
            // 删除管理员权限，等于1表示有该权限
            deleteUserManagement: JSON.parse(sessionStorage.getItem('authorizationObject')).delete_user_management,
        }
    },
    methods: {
        // 公司选项远程搜索
        remoteMethod(value) {
            this.$post('authority_management_user/getCompanyAdmin', {
                offset: 0,
                length: 20,
                company: value,
                token: this.$store.state.authority_management
            }).then(res => {
                this.adminList = res.data.result.data
            })
        },

        // 点击新增后台管理用户按钮
        handleClick() {
            // 验证数据
            if (this.validationData()) {
                // 处理权限数组
                this.handlePermissionList(this.permissionList);
                // 新建管理用户
                this.createUser();
            }
        },

        // 处理权限数组
        handlePermissionList(list) {
            for (let i = 0; i < list.length; i++) {
                this.result[list[i].permissionName] = list[i].permissionFlag == true ? '1' : '0';
                for (let j = 0; j < list[i].permissionDetail.length; j++) {
                    this.result[list[i].permissionDetail[j].permissionName] = list[i].permissionDetail[j].permissionFlag;
                }
            }
        },

        // 验证数据
        validationData() {
			let { name, password } = this.form;
			if (name == '') {
			    this.$message.error('请输入用户名称!');
			    return false;
			}
			if (name.length < 3) {
			    this.$message.error('用户名称长度必须大于等于3位!');
			    return false;
			}
			if (password == '') {
			    this.$message.error('请输入用户密码!');
			    return false;
			}
			if (password.length < 6) {
			    this.$message.error('用户密码长度必须大于等于6位');
			    return false;
			}
			
			return true;
		},

        // 新建管理用户
        createUser() {
            this.$post('authority_management_user/addManagementUser', {
                token: this.$store.state.authority_management,
                name: this.form.name,
                password: this.form.password,
                authorityJson: JSON.stringify(this.result),
            }).then(res => {
                if (res.data.status == 'success') {
                    this.$message.success('新增后台管理用户成功!');
                } else if (res.data.status == 'fail') {
                    this.$message.error(res.data.errorMsg);
                } else {
                    this.$message.error('新增后台管理用户失败!');
                }
                this.addUserVisible = false;
                this.getData();
            });
        },

        // 点击搜索按钮
        confirmSearch() {
            this.currentPage = 1;
            this.getData();
        },

       

        // 当前页显示数目改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        // 当前改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 点击修改按钮
        hadnleEdit(user) {
            // 显示修改对话框
            this.editUserVisible = true;

            // 赋值
            this.editForm.user_id = user.id;
            this.editForm.name = user.name;
            this.editForm.is_disabled = user.is_disabled;
            this.editForm.authority_management_id = user.authority_management_id;
            // 获取权限详情
            this.$post('authority_management/getAuthority', {
                token: this.$store.state.authority_management,
                authority_id: user.authority_management_id
            }).then(res => {
                console.log('res.data.result', res.data.result);
                // 处理返回的权限对象
                this.handleResult(res.data.result);
            });
        },


        // 处理返回的result对象
        handleResult(result) {
            let permissionList = this.permissionList;
            // 遍历权限数组
            permissionList.map(item1 => {

                // 遍历传递过来的权限对象
                // 将权限对象的属性赋值到权限数组对应对象的属性上
                for (let key in result) {
                    if (key == item1.permissionName) {
                        item1.permissionFlag = result[key] == 0 ? false : true;
                    }
                    item1.permissionDetail.map(item2 => {
                        if (key == item2.permissionName) {
                            item2.permissionFlag = result[key] + '';
                        }
                    })
                }
            });
            // 赋值
            this.editForm.permissionList = permissionList;
        },

        // 确认修改
        handleClickEdit() {
            // 先处理权限数组，将其处理成后端接收的类型
            this.handlePermissionList(this.editForm.permissionList);
            this.$post('authority_management_user/editManagementUser', {
                token: this.$store.state.authority_management,
                management_user_id: this.editForm.user_id,
                authorityJson: JSON.stringify(this.result),
                authority_id: this.editForm.authority_management_id,
            }).then(res => {
                if (res.data.status == 'success') {
                    this.$message.success(res.data.result);
                } else if (res.data.status == 'fail') {
                    this.$message.error(res.data.errorMsg);
                } else {
                    this.$message.error('修改失败，请重试!');
                }
                this.editUserVisible = false;
                this.getData();
            })
        },


		// 选择改变
		handleSelectionChange(value){
			let arr = [];
			for (let item of value) {
			    arr.push(item.id);
			}
			this.managementIds = arr;
		},
		
		// 删除管理员
		delectManagement(){
			if(this.managementIds.length != 1){
				this.$message({
					type:'error',
					message:'请选择一名管理员'
				})
				return
			}
			
			let data = {
				token :this.$store.state.authority_management,
				id : this.managementIds[0]
			}
			
			//删除请求
			this.$post('authority_management_user/deleteManagementUser',data).then(res=>{
				console.log(res)
				if(res.data.status == 'success'){
					this.getData();
					this.$message({
						type:'success',
						message:'删除成功'
					})
				}else{
					this.$message({
						type:'error',
						message:res.data.errorMsg
					})
				}
			})
			
		},

		// 获取用户数据
		getData() {
            let data = {
		        token: this.$store.state.authority_management,
		        offset: (this.currentPage - 1) * this.pageSize,
		        length: this.pageSize
		    }
            
            if(this.serachForm.name){
                data.name = this.serachForm.name
            }
            
		    this.$post('authority_management_user/managementUserList', data).then(res => {
				console.log(res)
		        this.tableData = res.data.result.data;
		        this.total = res.data.result.total;
		    })
		},
    },
    created() {
        // 获取数据
        this.getData();
    },

    components: {}

}